import React__default, { useContext, createContext } from 'react';
import { $ as $49c51c25361d4cd2$export$ee0f7cc6afcd1c18 } from './3rdPartyModules/_react-aria/overlays/dist/import-BMKLGELQ-BPxmZN3U.js';

const PreventScrollContext = /*#__PURE__*/createContext(false);
const PreventScroll = ({
  isScrollEnabled = false,
  children
}) => {
  const isPreventScroll = useContext(PreventScrollContext);
  $49c51c25361d4cd2$export$ee0f7cc6afcd1c18({
    isDisabled: isScrollEnabled ? true : isPreventScroll
  });
  if (isPreventScroll) {
    return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, children);
  }
  return /*#__PURE__*/React__default.createElement(PreventScrollContext.Provider, {
    value: true
  }, children);
};

export { PreventScroll as P };
//# sourceMappingURL=PreventScroll-C7cxX_Px-zZoGpe3b.js.map
